import { CalendarOutlined, WarningFilled } from "@ant-design/icons"
import { DatePicker, Form, Tooltip, Typography } from "antd"
import { type FormInstance } from "antd/es/form/hooks/useForm"
import dayjs from "dayjs"

import { useDateFormat } from "../../../../hooks/use-date-format.ts"
import { DATE_FORMAT } from "../../../../utils/date/date.ts"

type DefaultType = { due_date?: string | null; date: string }

interface ProjectViewFinanceCellDueDateProps<T> {
  form: FormInstance<T>
}

export function ProjectViewFinanceCellDueDate<T extends DefaultType>({
  form
}: ProjectViewFinanceCellDueDateProps<T>) {
  const { getDateValueProps, parseDate, userFormat } = useDateFormat()
  const due_date = Form.useWatch("due_date", form)
  const date = Form.useWatch("date", form)
  const parsedDue = parseDate(due_date)
  const parsedDate = parseDate(date)

  const isOverdue = parsedDue && dayjs(parsedDue).isBefore(dayjs(), "day")
  const isBackDated = !!(
    parsedDate && parsedDue && dayjs(parsedDate).isAfter(dayjs(parsedDue), "day")
  )
  const showWarning = isOverdue || isBackDated

  return (
    <Tooltip title={isOverdue ? "Overdue" : ""} color="orange">
      <td className="ant-table-cell">
        <Form.Item<DefaultType>
          name="due_date"
          noStyle
          getValueProps={getDateValueProps}
        >
          <DatePicker
            className="w-full"
            format={userFormat ?? DATE_FORMAT}
            status={showWarning ? "warning" : ""}
            suffixIcon={
              showWarning ? (
                <WarningFilled className="text-warning" />
              ) : (
                <CalendarOutlined />
              )
            }
          />
        </Form.Item>
        {isBackDated && (
          <Typography.Text
            type="warning"
            className="block text-xs leading-tight mt-0.5"
          >
            Date is after due date
          </Typography.Text>
        )}
      </td>
    </Tooltip>
  )
}
